import Vue from "vue";
import axios from "axios";

// import customSetting from "../../../public/config/customSetting.json";
Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
// const controller = customSetting.PrivacyZoneController;
const getController = self.customSetting.getPrivacyZone;
const postController = self.customSetting.postPrivacyZone;

export default {
  // 2-14
  getCstForChoice: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryPeople`)
        .then((res) => {
          context.commit("GET_CSTCHOICE_LIST", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addCstApplier: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/InsPrivicePeople`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getCstApplier: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryAgreementList`)
        .then((res) => {
          context.commit("GET_CSTAPPLIER_DATA", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 2-15
  getCstForCensor: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryPrivacyAgreement`)
        .then((res) => {
          context.commit("GET_CSTCENSOR_DATA", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  approveCst: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/ApproveAgreement`, data)
        .then((res) => {
          context.commit("GET_CSTCENSOR_DATA", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  rejectCst: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/RejectAgreement`, data)
        .then((res) => {
          context.commit("GET_CSTCENSOR_DATA", res.data);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
